import styled from 'styled-components';
import AppHeader from 'components/AppHeader';

export const Header = styled(AppHeader)`
  z-index: 2;
`;
